<!--
  @component
  Generates HTML text labels for a nested data structure. It places the label near the y-value of the highest x-valued data point. This is useful for labeling the final point in a multi-series line chart, for example. It expects your data to be an array of objects where each has `values` field that is an array of data objects. It uses the `z` field accessor to pull the text label.
 -->
<script>
	import { getContext } from "svelte";
	import { draw, fade } from "svelte/transition";
	import { quintOut } from "svelte/easing";

	const { data, xScale } = getContext("LayerCake");
</script>

{#each $data as group (group.id || group.topic)}
	{#if group.settings.rangeAnnotations}
		{#each group.settings.rangeAnnotations as { startValue, endValue, labelPosition, label, dateLabel }}
			<div
				class="Annotation__background"
				transition:fade={{ duration: 300, ease: quintOut }}
				style:left={`${$xScale(startValue)}px`}
				style:width={`${$xScale(endValue) - $xScale(startValue)}px`}
			>
				<div
					class="Annotation__label"
					style:top={labelPosition?.top ? `${labelPosition.top}%` : "unset"}
					style:bottom={labelPosition?.bottom ? `${labelPosition.bottom}%` : "unset"}
				>
					<span class="Annotation__label__date">{dateLabel}</span>
					<span class="Annotation__label__text">{label}</span>
				</div>
			</div>
		{/each}
	{/if}
{/each}

<style lang="scss">
	.Annotation {
		&__background {
			position: absolute;
			top: 0;
			height: 100%;

			&:after {
				content: "";
				// background-color: rgba(255, 255, 255, 0.2);
				opacity: 0.15;
				background: linear-gradient(180deg, #d9d9d9 0%, rgba(217, 217, 217, 0.63) 74.48%, rgba(217, 217, 217, 0) 100%);
				height: 100%;
				width: 100%;
				position: absolute;
			}
		}

		&__label {
			position: absolute;
			bottom: 20px;
			left: 50%;
			transform: translateX(-50%);
			opacity: 0.8;

			&__date,
			&__text {
				display: block;
				text-align: center;
				text-shadow: 0px 0px 10px #211c46;
				font-size: 11px;
				font-style: normal;
				font-weight: 400;
				line-height: 115%;
				white-space: nowrap;
			}

			&__date {
				color: #736e81;
			}

			&__text {
				color: #fff;
			}
		}
	}
	// .annotation {
	// 	position: absolute;
	// 	font-family: Franklin Gothic FS;
	//  transform: translate(-20px, -20px);

	// 	&__text, &__date-text {
	// 		white-space: normal;
	// 		display: block;
	// 		font-size: 12px;
	// 		font-style: normal;
	// 		line-height: 120%;
	// 		text-align: center;
	//   color: #fff;
	//   max-width: 60px;
	// 		// text-shadow: -1px -1px 0 #211C46, 1px -1px 0 #211C46, -1px 1px 0 #211C46, 1px 1px 0 #211C46;
	// 	}

	// 	&__date-text {
	// 		opacity: 0.7;
	// 	}

	//  &__text {
	//   font-weight: $medium;
	//  }

	// 	&__main {
	// 		font-weight: 400;
	// 	}
	// }
</style>
